export default function useValidation(versionId, metadata, requirements) {
  const versionReqs = requirements[versionId];
  for (const field of versionReqs) {
    if (!metadata[field]) return false;
  }
  return true;
}
